import { render } from "./PrivacyTc.vue?vue&type=template&id=c7d59e90"
import script from "./PrivacyTc.vue?vue&type=script&lang=js"
export * from "./PrivacyTc.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__